import React from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

export default function PublicFooter() {
  return (
    <footer className="nhsuk-footer pguh-public-footer" role="contentinfo">
      <div className="nhsuk-width-container">
        <div className="pguh-public-footer__grid">
          <div>
            <h2>Royal University Hospitals Trust</h2>
            <p>
              Public information, recruitment and digital patient services for
              Prince George University Hospital and Duke of York Hospital.
            </p>
          </div>

          <nav aria-label="Public footer links">
            <h2>Useful links</h2>
            <ul>
              <li><Link to="/vacancies">Vacancies</Link></li>
              <li><Link to="/patient-portal">Patient portal</Link></li>
              <li><Link to="/login">Staff login</Link></li>
            </ul>
          </nav>

          <nav aria-label="Policies">
            <h2>Policies</h2>
            <ul>
              <li><Link to="/terms">Terms of service</Link></li>
              <li><Link to="/privacy">Privacy policy</Link></li>
              <li><Link to="/gdpr">Data protection and GDPR</Link></li>
            </ul>
          </nav>
        </div>

        <div className="pguh-public-footer__meta">
          <div className="pguh-public-footer__meta-copy">
            <span>© {new Date().getFullYear()} Royal University Hospitals Trust</span>
            <span>RUHT digital services</span>
          </div>

          <ThemeToggle />
        </div>
      </div>
    </footer>
  );
}
